import { Component } from 'react';
import { node, string, bool } from 'prop-types';
import Anchor from 'components/base/Anchor/Anchor';

/** Renders a Link in all its variations based on the Markdown input */
class LinkRenderer extends Component {
  render() {
    const { href, children, modal } = this.props;

    const isGlossary = href.indexOf('/glossary') === 0;

    return (
      <Anchor
        to={{
          pathname: href,
          state: {
            modal: modal && isGlossary,
          },
        }}
      >
        {children}
      </Anchor>
    );
  }
}

LinkRenderer.propTypes = {
  /** The children nodes that will be wrapped by this component */
  children: node.isRequired,
  /** The href attribute that will be used as the to property of the React Router Link */
  href: string.isRequired,
  /** Boolean indicating if this page is displayed in a modal */
  modal: bool,
};

export default LinkRenderer;
